import SliderDropdown from "@stadium/ui/src/components/SliderDropdown";

import AuthLogin from "@components/auth/buttons/login";
import { InternalButton, ExternalButton } from "@sharedComponents/buttons";

import { DROPDOWN_ITEMS } from "@components/swagmagic/profile-dropdown/unauthenticated-button/constants";
import { HELP_CENTER_URL } from "@stadium/constants/routes";

import styles from "./main.module.scss";

const ResponsiveUnauthenticatedButton = ({ className = "" }) => {
  const renderDropdownItems = () =>
    DROPDOWN_ITEMS.map(({ btnText, loginOptions }) => (
      <AuthLogin className={styles.loggedOutUserBlock} loginOptions={loginOptions} key={btnText}>
        <InternalButton styleType="link" className={`${styles.userLoginOptions} ${className}`}>
          {btnText}
        </InternalButton>
      </AuthLogin>
    ));
  const renderLabel = () => (
    <>
      <span className={styles.userIcon} />
      <p className={styles.categoryText}>Profile</p>
    </>
  );
  return (
    <SliderDropdown
      styles={styles}
      label={renderLabel()}
      backLabel="Profile"
      ariaLabel="Profile Dropdown"
    >
      <>
        {renderDropdownItems()}
        <ExternalButton
          btnStyle="link"
          href={HELP_CENTER_URL}
          className={styles.helpCenterLink}
          title="Help Center"
        >
          <span className={styles.iconHelp}></span>
          <span className={styles.profileHelpButtonText}>Help Center</span>
        </ExternalButton>
      </>
    </SliderDropdown>
  );
};

export default ResponsiveUnauthenticatedButton;
